import { render, staticRenderFns } from "./ArticuloClases.vue?vue&type=template&id=15d7adf3&"
import script from "./ArticuloClases.vue?vue&type=script&lang=js&"
export * from "./ArticuloClases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports